import { ClearOutlined } from '@ant-design/icons'
import { Button, Form, Input, InputNumber, Table } from 'antd'
import { FC } from 'react'
import useFiltersForm from '../../../../../hooks/forms/use-filters-form'

interface FiltersFormProps {}

const FiltersForm: FC<FiltersFormProps> = () => {
    const { form, onSearch, onClear } = useFiltersForm()

    return (
        <Form
            form={form}
            component={false}
            variant={'filled'}
            onFieldsChange={() => {
                onSearch()
            }}
        >
            <Table.Summary.Row>
                <Table.Summary.Cell index={0}>
                    <Form.Item name={'setId'} noStyle>
                        <InputNumber
                            style={{ width: '100%' }}
                            controls={false}
                            placeholder={'Номер набора'}
                        />
                    </Form.Item>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1}>
                    <Form.Item name={'formNum'} noStyle>
                        <Input placeholder={'Номер формы'} />
                    </Form.Item>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} />
                <Table.Summary.Cell index={3} />
                <Table.Summary.Cell index={4} />
                <Table.Summary.Cell index={5} />
                <Table.Summary.Cell index={6} />
                <Table.Summary.Cell index={7} />
                <Table.Summary.Cell index={8}>
                    <Button
                        size={'small'}
                        icon={<ClearOutlined />}
                        title={'Сбросить фильтры'}
                        onClick={onClear}
                    >
                        Сброс
                    </Button>
                </Table.Summary.Cell>
            </Table.Summary.Row>
        </Form>
    )
}

export default FiltersForm
